<script>
import TextAccordion from "@js/components/Sections/TextBlocks/TextAccordion.vue";

export default {
    name: "ProductSelfPickupInfo",
    components: {TextAccordion}
}
</script>

<template>
    <div class="p-5 border border-gray-200 shadow-sm bg-[#d1ecf1] rounded-lg">
        <div class="text-base font-bold text-black mb-5">
            Как забрать самовывозом
        </div>
        <TextAccordion :minHeight="75">
            <ul class="max-w-md space-y-4 list-disc list-outside text-white text-base md:text-xl ms-6">
                <li class="text-xs text-black font-medium">
                    Для удобства клиентов компания ООО «Дорожные Плиты» предоставляет возможность самовывоза продукции с
                    нашей базы. Вы можете самостоятельно забрать заказанные плиты в удобное для вас время, следуя
                    простому алгоритму.
                </li>
                <li class="text-xs text-black font-medium">
                    Сначала необходимо оформить заказ, выбрав нужное количество и тип ЖБИ. После подтверждения
                    менеджером вам будет выставлен счет для оплаты.
                </li>
                <li class="text-xs text-black font-medium">
                    После оплаты согласуйте с менеджером точное время, когда вы сможете забрать продукцию. Это позволит
                    избежать задержек и обеспечит быструю загрузку на месте.
                </li>
                <li class="text-xs text-black font-medium">
                    В назначенное время приезжайте на нашу базу, где хранятся изделия, и осуществите самовывоз с учетом
                    всех требований по транспортировке. Наши сотрудники помогут организовать процесс погрузки, чтобы ваш
                    заказ был безопасно размещен в транспортном средстве.
                </li>
            </ul>
        </TextAccordion>
    </div>
</template>

<style scoped lang="scss">

</style>
